import styled from "styled-components";

export const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-bottom: 14px;

  h2 {
    margin-bottom: 0px;
    width: 80%;
    text-align: left;

    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }

  h3 {
    font-size: 22px;
    font-weight: 600;
    line-height: 54px;
    width: 80%;

    @media screen and (max-width: 767px) {
      width: 100%;
    }
  }

  a {
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 600;

    @media screen and (max-width: 767px) {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 1023px) {
    flex-direction: column;
    align-items: start;
    justify-content: center;
    gap: 8px;

    h2 {
      font-size: 32px;
      font-weight: 600;
      line-height: 36px;
      margin-bottom: 0;

      @media screen and (max-width: 767px) {
        font-size: 22px;
        line-height: 22px;
      }
    }
  }
`;
